<div class="icon">
  <cx-icon type="CARD_PLUS"></cx-icon>
</div>
<div class="text">Новая карта</div>
